// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarMenu_wrapper__AJYYr","title":"SidebarMenu_title__Prrx-"};